/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SignInRequest = zod
	.object({
		identifier: zod.string().describe('Email or username'),
		password: zod.string().describe('Password')
	})
	.describe('Sign in request body');

export type SignInRequest = zod.input<typeof SignInRequest>;
export type SignInRequestOutput = zod.output<typeof SignInRequest>;
